<template>
	<!-- 忘记密码 -->
	<div class="box">
		<el-row class="main">
			<el-col :span="12" class="main_con">
				<div class="logo_box">
                    <Logo></Logo>
				</div>
                <div class="content" v-if="!accountVisibility">
                    <h3>找回密码</h3>
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                        <el-form-item prop="phoneNumber">
                            <el-input
                              placeholder="手机号"
                              v-model="ruleForm.phoneNumber"
                              @blur="checkPhone"
                              clearable>
                            </el-input>
                          </el-form-item>
                          <el-form-item prop="verificationCode" class="verificationCode">
                            <el-row>
                                <el-col :span="16">
                                    <el-input v-model="ruleForm.verificationCode" placeholder="短信验证码"></el-input>
                                </el-col>
                                <el-col :span="8">
                                    <div @click="getCode" class="button" :class="{ disButton: disabled }">
                                        {{buttonName}}
                                    </div>
                                </el-col>
                            </el-row>
                          </el-form-item>
                    </el-form>
                    <div @click="backAccount" class="backButton">立即找回</div>
                </div>
                <!-- 已找回密码 -->
                <div class="content" v-if="accountVisibility">
                    <div class="demand">
						<span>设置新密码</span>
						<div>密码需要满足以下要求</div>
						<div><i class="el-icon-circle-check"></i>至少8个字符</div>
						<div><i class="el-icon-circle-check"></i>至少包含字母和数字，不能包含空格</div>
					</div>
					<el-form ref="form" :model="form" :rules="formRules" class="form">
						<el-form-item prop="password">
							<el-input v-model="form.password"  placeholder="密码"></el-input>
						</el-form-item>
						<el-form-item prop="confirmPassword">
							<el-input v-model="form.confirmPassword"  placeholder="确认密码"></el-input>
						</el-form-item>
					</el-form>
                    <div class="backButton" @click="confirm">确定</div>
                </div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
    import { getVerificationCode, validVerificationCode } from '@/api/sms.js'
    import { webForgetPassword } from '@/api/login/forgetPwd.js'
    import Logo from '@/components/common/logo.vue'
    export default {
        components: {
            Logo,
        },
        data() {
            let validateCode = (rule, value, callback) => {
                if (value == '') {
                    callback(new Error('请输入验证码'))
                } else if (value != this.correctCode) {
                    callback(new Error('验证码有误或已过期'))
                } else {
                    callback()
                }
            };
            let validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else if (value != '') {
                    let re = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
                    let res = re.test(value);
                    if (!res) {
                        callback(new Error('密码设置不符合要求！请重新输入'));
                    }
                } else {
                    if (this.ruleForm.checkPass !== '') {
                        this.$refs.form.validateField('confirmPassword');
                    }
                    callback();
                }
            };
            let validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.ruleForm.pass) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                ruleForm: {
                    phoneNumber: '', //手机号
                    verificationCode: '', //验证码
                },
                rules: {
                    phoneNumber: [{
                        required: true,
                        message: '请输入手机号',
                        trigger: 'blur'
                    }, {
                        pattern: /^[1][3,4,5,7,8][0-9]{9}$/,
                        message: '请输入正确的手机号码',
                        trigger: 'blur'
                    }],
                    verificationCode: [{
                        required: true,
                        message: '请输入验证码',
                        trigger: 'blur',
                    }, {
                        validator: validateCode,
                        trigger: 'blur'
                    }],
                },
                count: 0, //倒计时秒数
                disabled: true,
                phoneChecked: false,
                buttonName: '发送验证码',
                timer: null,
                correctCode: '123456', //正确的验证码
                accountVisibility: false, //已找回账号
                account: 'yahhh', //账号
                form: {
                    password: '',
                    confirmPassword: '',
                },
                formRules: {
                    password: [{
                        validator: validatePass,
                        trigger: 'blur'
                    }],
                    confirmPassword: [{
                        validator: validatePass2,
                        trigger: 'blur'
                    }],
                }
            }
        },
        watch: {
            //监听短信登录手机号是否输入
            'ruleForm.phoneNumber': function(val) {
                if (val == '') {
                    this.disabled = true;
                } else {
                    this.disabled = false;
                }
            }
        },
        methods: {
            //校验手机号输入是否正确
            checkPhone() {
                this.$refs['ruleForm'].validateField('phoneNumber', (error) => {
                    if(!error) {
                        this.disabled = false;
                        this.phoneChecked = true;
                    } else {
                        this.disabled = true;
                        this.phoneChecked = false;
                        return false;
                    }
                })
            },
            //获取验证码
            getCode() {
                if (this.phoneChecked && this.count == 0) {
                    let param = {
                        phone: this.ruleForm.phoneNumber.trim(),
                        status: '3',
                    }
                    getVerificationCode(param).then(res => {
                        this.$message.success('验证码发送成功！');
                        this.getCorrectCode();
                        //验证码倒计时
                        if (!this.timer) {
                            this.count = 60;
                            this.disabled = true;
                            this.timer = setInterval(() => {
                                if (this.count > 0 && this.count <= 60) {
                                    this.count--;
                                    let nowCountDown = this.count;
                                    this.buttonName = `${nowCountDown}s 后重新发送`;
                                } else {
                                    this.disabled = false;
                                    this.buttonName = '发送验证码';
                                    clearInterval(this.timer);
                                    this.timer = null;
                                }
                            }, 1000)
                        }
                    })
                } else {
                    return;
                }
            },
            //获取正确的短信验证码
            getCorrectCode() {
                let param = {
                    phone: this.ruleForm.phoneNumber,
                    status: '3',
                }
                validVerificationCode(param).then(res => {
                    this.correctCode = res.data;
                })
            },
            //立即找回
            backAccount() {
                if (this.ruleForm.phoneNumber != '' && this.ruleForm.verificationCode != '') {
                    this.$refs['ruleForm'].validate((valid) => {
                        if (valid) {
                            this.accountVisibility = true;
                        } else {
                            return false;
                        }
                    })
                } else {
                    return;
                }
            },
            //确认密码
            confirm() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        let password = this.form.password;
                        let phone = this.ruleForm.phoneNumber;
                        webForgetPassword(password, phone).then(res => {
                            this.$message.success('密码重置成功!');
                            this.$router.push({path: '/login'})
                        })
                    } else {
                        return false;
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped="scoped">
    .box {
        width: 100%;
        background: url(../../assets/common/login_background.png) no-repeat center center;
        background-size: 100% 100%;
    }
    
    .main {
        display: flex;
        justify-content: center;
        padding: 60px 0 250px 0;
    }
    
    .main_con {
        height: 666px;
        background-color: #fff;
    }
    /* logo */
    
    .logo_box {
        border-bottom: 1px solid rgba(212, 212, 212, 1);
        padding: 20px 0 15px 20px
    }
    
    /* content */
    
    .content {
        padding: 30px 28%;
        text-align: center;
    }
    
    .content h3 {
        margin-bottom: 50px;
        font-size: 30px;
        font-weight: 400;
        color: #507DF1;
    }
    
    .verificationCode {
        margin-bottom: 70px;
    }
    
    .button {
        width: 90%;
        height: 40px;
        margin-left: 10%;
        border: none;
        background-color: rgba(87, 131, 238, 1);
        font-size: 12px;
        color: #fff;
        /* line-height: 40px; */
        border-radius: 6px;
    }
    
    .button:hover {
        cursor: pointer;
    }
    
    .disButton {
        width: 90%;
        height: 40px;
        margin-left: 10%;
        border: none;
        background-color: #ECECEC;
        font-size: 12px;
        color: #AAA;
        border-radius: 6px;
    }
    
    .disButton:hover {
        cursor: not-allowed;
    }
    
    .backButton {
        width: 100%;
        height: 55px;
        background-color: rgba(87, 131, 238, 1);
        font-size: 20px;
        color: #fff;
        line-height: 55px;
        border-radius: 6px;
    }
    
    .backButton:hover {
        cursor: pointer;
    }
    /* 已找回密码界面 */
    
    .demand {
        margin: 50px 0 0 0;
        font-size: 12px;
        color: #AAA;
        text-align: left;
        line-height: 25px;
    }
    
    .demand span {
        font-size: 20px;
        color: #507DF1;
    }
    
    .form {
        margin: 20px 0 50px;
    }
</style>